import moment from 'moment';

export default function getAnneeSemaineFromDate(date) {
  if (!date) return null;
  return moment(date).format('GGGGWW');
}



// WEBPACK FOOTER //
// ./src/services/general/getAnneeSemaineFromDate.js